import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyPersonalDriverDataQueryType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPersonalDriverData/patchBodyPersonalDriverDataQuery.type';

export const patchBodyPersonalDriverDataQueryFunction = (
  params: PatchBodyPersonalDriverDataQueryType,
) => {
  const formattedParams = {
    ...params.data,
    birthdate: convertPersianToGregorian(params.data.birthdate.toString()),
  };

  return fetchApi.patch(
    `/body/reports/${params?.id}/insurer_information/driver/personal_information/`,
    formattedParams,
  );
};
